import React from 'react'
import SanitizeHtml from '../SanitizeHtml/SanitizeHtml'

const Alert = ({ messages = [], type = 'danger', alternativeWarning }) => {
  const ulClassName = messages.length > 1 ? 'm-0 px-4' : 'm-0'
  const liStyle = messages.length > 1 ? { listStyleType: 'disc' } : undefined
  return (
    <div className={`alert alert-${type}`} role="alert">
      {type === 'warning' && !alternativeWarning && (
        <i className="icon-warning"></i>
      )}
      {alternativeWarning && (
        <i className="icon-alert-warning" style={{ fontSize: 18 }}></i>
      )}
      <ul className={ulClassName}>
        {messages.map((msg, index) => (
          <li key={index} style={liStyle}>
            <SanitizeHtml html={msg} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Alert
